import * as Effects from 'redux-saga/effects'
import requestInvoice from '../../../actions/invoices/requestInvoice'
import { InvoiceActions } from '../../../reducers/invoice/actionNames'
import { getInvoiceReservationId } from '../../../reducers/invoice/getInvoice'

function* reload() {
  const id = yield Effects.select(getInvoiceReservationId)
  yield Effects.put(requestInvoice(id))
}

export default function* () {
  yield Effects.takeEvery(InvoiceActions.Reload, reload)
}
